import React from "react";
import styles from "./style.module.scss";

const OTPInput = ({ value, onInput }) => {
  return (
    <React.Fragment>
      <div className={styles.otpInput}>
        <div className={styles.otpInput_item}></div>
        <div className={styles.otpInput_item}></div>
        <div className={styles.otpInput_item}></div>
        <div className={styles.otpInput_item}></div>
        <div className={styles.otpInput_item}></div>
        <input
          type="text"
          value={value}
          maxLength="5"
          className={styles.otpInput_input}
          onChange={onInput}
        />
      </div>
    </React.Fragment>
  );
};

export default OTPInput;
